import { UniversalFilterConfig } from '../../components/Filters/ReportFilter';
import { activeStatusReportOptions } from '../../data/report/status/activeStatusReportOptions';
import { documentStatusReportOptions } from '../../data/report/status/documentStatusReportOptions';

/**
 * Contexto con todos los dropdowns disponibles para reportes.
 *
 * Cada campo es opcional porque
 * no todos los reportes usan todo.
 */
export interface ReportFilterResolverContext {
  productsDropdown?: any[];
  productCategoriesDropdown?: any[];
  productUnitsDropdown?: any[];

  customersDropdown?: any[];

  suppliersDropdown?: any[];
  documentTypeDropdown?: any[];
  branchDropdown?: any[];
  paymentConditionDropdown?: any[];

  taxpayerCategoryDropdown?: any[];
  economicActivitiesDropdown?: any[];
}

/**
 * Resuelve dinámicamente las opciones
 * de los filtros de reportes
 * según el nombre del filtro.
 */
export const resolveReportFilters = (
  baseFilters: UniversalFilterConfig[],
  context: ReportFilterResolverContext
): UniversalFilterConfig[] => {
  return baseFilters.map((filter) => {
    const optionResolver: Record<string, any[] | undefined> = {
      // =========================
      // Productos
      // =========================
      productId: context.productsDropdown,
      categoryId: context.productCategoriesDropdown,
      unitId: context.productUnitsDropdown,

      // =========================
      // Clientes
      // =========================
      customerId: context.customersDropdown,

      // =========================
      // Proveedores
      // =========================
      supplierId: context.suppliersDropdown,

      // =========================
      // Documentos / sucursales
      // =========================
      documentTypeId: context.documentTypeDropdown,
      branchId: context.branchDropdown,
      paymentConditionId: context.paymentConditionDropdown,

      // =========================
      // Tributarios
      // =========================
      taxpayerCategoryId: context.taxpayerCategoryDropdown,
      economicActivityId: context.economicActivitiesDropdown,

      // =========================
      // Estado documento
      // =========================
      status: documentStatusReportOptions,

      // Estado general Activo/Inactivo
      activeStatus: activeStatusReportOptions,
    };

    const options = optionResolver[filter.name];

    return options
      ? {
        ...filter,
        options,
      }
      : filter;
  });
};